import { render, staticRenderFns } from "./result-win-detail.vue?vue&type=template&id=08f7a734&scoped=true&"
import script from "./result-win-detail.vue?vue&type=script&lang=js&"
export * from "./result-win-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7a734",
  null
  
)

export default component.exports